// extracted by mini-css-extract-plugin
module.exports = {"container":"_3lkU39","item":"qW2AQO","icon":"_2QeSR8","time":"BNm1sn","label":"_1-OZzy","item--return":"_3C9BEN"};